<template>
  <div style="background-color: #111130;    text-align: -webkit-center;">
    <v-row style="padding-top: 10px!important;
    padding-bottom: 10px!important;
   max-width: 1200px">
      <v-col style="padding: 0" cols="12 col-sm-6">
        <v-row>
          <v-col style="padding: 0" cols="8">
            <MainBox :title="$t('tamirat')" @click.native="goToDetail('5','tamirat')"  class="tamirat main-box-large large-box-icon" image="/main_icons/tamirat.svg"/>
          </v-col>
          <v-col style="padding: 0" cols="4">
           <v-row>
             <v-col style="padding: 0" cols="12">
               <MainBox :title="$t('network')" @click.native="goToDetail('26','network')" class="network main-box " image="/main_icons/network.svg"/>
             </v-col>
             <v-col style="padding: 0" cols="12">
               <MainBox :title="$t('software')" @click.native="goToDetail('28','software')" class="software main-box " image="/main_icons/software.svg"/>
             </v-col>
           </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding: 0" cols="4">
            <v-row>

              <v-col style="padding: 0" cols="12">
                <MainBox :title="$t('messenger')" @click.native="go_to_messenger()" class="messenger main-box-rect-rev  large-box-icon" image="/main_icons/messenger_icon.svg"/>
              </v-col>
              <v-col style="padding: 0" cols="12">
                <MainBox :title="$t('jobs')" @click.native="goToDetail('29','jobs')" class="jobs main-box " image="/main_icons/jobs.svg"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col style="padding: 0" cols="8">
            <v-row>
              <v-col style="padding: 0" cols="6">
                <MainBox :title="$t('Decoration')" @click.native="goToDetail('23','design')" class="design main-box " image="/main_icons/design.svg"/>
              </v-col>
              <v-col style="padding: 0" cols="6">
                <MainBox :title="$t('advertise')" @click.native="goToDetail('25','ads')" class="ads main-box " image="/main_icons/ads.svg"/>
              </v-col>
            </v-row>
            <v-row style="aspect-ratio: 1;
    padding-bottom: 10px;">
              <v-col style="padding: 0" cols="12" >
                <MainBox :title="$t('zoodkomakCity')" class="metaverse large-box-icon main-box-large " image="/main_icons/metaverse1.jpg"/>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12 col-sm-6" style="padding: 0">
        <v-row>
          <v-col style="padding: 0" cols="8">
            <MainBox :title="$t('tasisat')" @click.native="goToDetail('19','building')" class="building main-box-rect no-mt-mobile" image="/main_icons/building.svg"/>
          </v-col>
          <v-col style="padding: 0" cols="4">
            <MainBox :title="$t('food')" @click.native="goToDetail('30','food')" class="food main-box  no-mt-mobile" image="/main_icons/food.svg"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding: 0" cols="4">
            <MainBox :title="$t('addCompany')" @click.native="goToDetail('24','company')" class="company main-box " image="/main_icons/company.svg"/>
          </v-col>
          <v-col style="padding: 0" cols="8">
            <MainBox :title="$t('shop')" class="shop main-box-rect " image="/main_icons/shop.svg"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding: 0" cols="8">
            <MainBox :title="$t('goldenCard')" @click.native="goToGoldenCard()" class="golden-card main-box-rect " image="/main_icons/golden_card.svg"/>
          </v-col>
          <v-col style="padding: 0" cols="4">
            <MainBox :title="$t('warranty')" class="guarante main-box " image="/main_icons/guarante.svg"/>
          </v-col>
        </v-row>
<!--        <v-row>-->
<!--          <v-col style="padding: 0" cols="12">-->
<!--            <MainBox class="summary_box box-no-icon main-box " image="/main_icons/company.svg" title="لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد." />-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-row>
          <v-col style="padding: 0" cols="4">
            <MainBox :title="$t('blog')" class="blog main-box " @click.native="goToBlog()" image="/main_icons/blog.svg"/>
          </v-col>
          <v-col style="padding: 0" cols="4">
<!--            <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=303769&amp;Code=WAxrXd5NiVjyjgIB3wZK">-->
<!--              <img loading="lazy" referrerpolicy="origin" src="/images/star1.png" alt="" style="cursor:pointer;width: 90px;height: 75px" id="WAxrXd5NiVjyjgIB3wZK">-->
<!--            </a>-->
            <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=303769&amp;Code=WAxrXd5NiVjyjgIB3wZK">
              <MainBox :title="$t('enamd')" class="enamad main-box " image="/img/enamad.png"/>
            </a>
          </v-col>
          <v-col style="padding: 0" cols="4">
            <MainBox :title="$t('samandehi')" class="samandehi main-box " image="/img/samandehi.png"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>

</template>
<script>
  import { bus } from '../../main.js'
import MainBox from '../../components/MainBox'
  export default {
    data () {
      return {
        tab: null,
        accept_device: false,
        app_version: process.env.VUE_APP_VERSION_CODE,

      }
    },
    components: {
      MainBox
    },
    mounted () {
      this.check_user_in_zoodkomak()
      // this.technician_login()
      Notification.requestPermission(permission => {
        if (permission === 'granted') {
          this.registerBackgroundSync()
        } else console.error('Permission was not granted.')
      })

      if (this.$route.params.cat_id != null) {
        this.go_to_posts(this.$route.params.cat_id, '', this.$route.params.group_id, this.$route.params.subgroup_id, this.$route.params.post_id, this.$route.params.post_title, this.$route.params.brand_id)
      }
      if (this.$route.params.item_id != null) {
        this.goToDetail(this.$route.params.item_id, this.$route.params.class)
      }
    },
    methods: {
      goToDetail (item_id, class_id) {
        var PassingData = {}
        localStorage.setItem('request_data', JSON.stringify(PassingData))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.cat_id = item_id
        passing_data.class_id = class_id
        passing_data.request_name = ' '
        localStorage.setItem('request_data', JSON.stringify(passing_data))

        this.$router.push({ name: 'groups', params: {} })
      },
      go_to_posts (cat_id, class_id, group_id, subgroup_id, post_id, post_title, brand_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.cat_id = cat_id
        passing_data.class_id = class_id
        passing_data.sub_group_id = subgroup_id
        passing_data.group_id = group_id

        passing_data.original_cat_id = cat_id
        passing_data.request_name = ' '
        passing_data.post_id = post_id
        passing_data.post_name = post_title
        passing_data.post_brand_id = brand_id

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        // this.$router.push({ path: '/brands', params: {} })
        this.$router.push({ name: 'request_detail', params: {} })
      },
      go_to_messenger () {
        var profile = localStorage.getItem('profile')
        if (profile == null) {
          this.$router.push({ path:'/login' })
        }
        var phone = localStorage.getItem('phone')
        var password = localStorage.getItem('password')
        var data = {
          name:JSON.parse(profile).UserName,
          phone:phone,
          password:password
        }
        var json_data = JSON.stringify(data)
        var cesar_data = this.caesar(json_data)
        // var encode_data = unescape(encodeURIComponent(cesar_data))
        var encode_data = (encodeURIComponent(cesar_data))
        // var base64_data = btoa(encode_data)
        var final_url = 'https://zoodpayam.com/#/login/' + encode_data
        // console.log('cesar data = ',cesar_data)
        // console.log('encode data = ',encode_data)
        // console.log('base64 data = ',base64_data)
        //
        // var un_base64_data = atob(base64_data);
        // var un_decode_data = decodeURIComponent(un_base64_data);
        // var decesar = this.decaesar(un_decode_data);
        // console.log('base64 decode = ',un_base64_data)
        // console.log('decode decode = ',un_decode_data)
        // console.log('decesar decode = ',decesar)
        console.log('final url = ', final_url)
        window.open(final_url)
        // this.$router.push({path:'/message-tab'})
      },
      go_to_profile () {
        var profile = localStorage.getItem('profile')
        if (profile == null) {
          this.$router.push({ path:'/login' })
        }
        var phone = localStorage.getItem('phone')
        var password = localStorage.getItem('password')
        var data = {
          name:JSON.parse(profile).UserName,
          phone:phone,
          password:password
        }
        var json_data = JSON.stringify(data)
        var cesar_data = this.caesar(json_data)
        // var encode_data = unescape(encodeURIComponent(cesar_data))
        var encode_data = (encodeURIComponent(cesar_data))
        // var base64_data = btoa(encode_data)
        var final_url = 'https://profile.zoodkomak.com/login-api/' + encode_data

        // console.log('cesar data = ',cesar_data)
        // console.log('encode data = ',encode_data)
        // console.log('base64 data = ',base64_data)
        //
        // var un_base64_data = atob(base64_data);
        // var un_decode_data = decodeURIComponent(un_base64_data);
        // var decesar = this.decaesar(un_decode_data);
        // console.log('base64 decode = ',un_base64_data)
        // console.log('decode decode = ',un_decode_data)
        // console.log('decesar decode = ',decesar)
        // console.log('final url = ',final_url)
        window.open(final_url)
        // this.$router.push({path:'/message-tab'})
      },
       caesar (str) {
    str = str.split('')
    str = str.map(char => {
      let code = char.charCodeAt(0)

      // if( (code > 64 && code < 78) || (code > 96 && code < 110) )
        code += 85

      // else if ( (code > 77 && code < 91) || (code > 109 && code < 123) )
      //   code -= 13

      return String.fromCharCode(code)
    })

    return str.join('')
  },
      decaesar (str) {
    str = str.split('')
    str = str.map(char => {
      let code = char.charCodeAt(0)

      // if( (code > 64 && code < 78) || (code > 96 && code < 110) )
        code -= 85

      // else if ( (code > 77 && code < 91) || (code > 109 && code < 123) )
      //   code -= 13

      return String.fromCharCode(code)
    })

    return str.join('')
  },
      registerBackgroundSync () {
        if (!navigator.serviceWorker) {
          return console.error('Service Worker not supported')
        }

        navigator.serviceWorker.ready
          .then(registration => registration.sync.register('syncAttendees'))
          .then(() => console.log('Registered background sync'))
          .catch(err => console.error('Error registering background sync', err))
      },
      technician_login () {
        var self = this
        var eddited_mobile = localStorage.getItem('phone')
        var password = localStorage.getItem('password')

        const send_data = {
          Phone: eddited_mobile,
          Password: password,
          OsName: 'UserPwA',
          AppNo: '5',
          OsVersion: '5',
          DeviceModel: 'android',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/Activate', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('version is ', self.app_version, response.data.newVersion.VersionCode)
              if (self.app_version < response.data.newVersion.VersionCode) {
                console.log('must reload')
                // window.location.reload()
                if ('serviceWorker' in navigator) {
                  caches.keys().then(function (cacheNames) {
                    cacheNames.forEach(function (cacheName) {
                      caches.delete(cacheName)
                    })
                  })
                }
                window.location.reload(true)
              }
            } else {
              localStorage.setItem('profile', '')
              localStorage.setItem('phone', '')
              localStorage.setItem('password', '')
              localStorage.setItem('party_id', '')
              self.$router.push({ name: 'login', params: {} })

              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          // this.errors.push(e);
          // bus.$emit('show_toast', [2000, e])

        })
      },

      check_user_in_zoodkomak () {
        if(localStorage.getItem('profile')==null){
          return
        }
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var user_name = JSON.parse(localStorage.getItem('profile')).UserName

        const send_data = {
          MobileNo: localStorage.getItem('phone').replace('+98', ''),
          Pass: localStorage.getItem('password'),
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, { show_pros: false })
          .then(response => {
            localStorage.setItem('userId2', response.data.UserId)
            const send_data = {
              UserName: user_name,
              UserId: response.data.UserId,
              MobileNo: localStorage.getItem('phone'),
              Password: localStorage.getItem('password'),
            }
            var formData = new FormData()
            formData.append('UserName', user_name)
            formData.append('UserId', response.data.UserId)
            formData.append('MobileNo', localStorage.getItem('phone'))
            formData.append('Password', localStorage.getItem('password'))
            // this.axios.post('/Register' , send_data,{
            self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, { show_pros: false })
              .then(response => {
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      goToBlog () {
        this.$router.push({ path:'/blog' })
      },

      goToGoldenCard () {
        this.$router.push({ path:'/golden-card' })
      }

    }
  }
</script>
